import React, { Component } from "react";
import { connect } from "react-redux";
import { Picky } from "react-picky";
import "react-picky/dist/picky.css";
import { filterBusList } from "../actions/main";
import Grid from "@material-ui/core/Grid";
import { FILTERS } from "../utils/constants";
import "../App.scss";

class BoardDropingPoints extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      selected: []
    };
  }

  componentDidMount() {
    const value = this.props.match.params.type;
    let bus = this.props.busListingReducer.noFilterbuses;
    let filters = this.props.busListingReducer.filters;
    let selected = this.state.selected;
    let type = "";
    let data = [];

    if (filters.FILTER_BOARDING.length > 0) {
      filters.FILTER_BOARDING.forEach(s => {
        selected.push(s);
      });
    }
    if (filters.FILTER_DROPPING.length > 0) {
      filters.FILTER_DROPPING.forEach(s => {
        selected.push(s);
      });
    }

    value === "boarding"
      ? (type = "DeparturePoints")
      : (type = "ArrivalPoints");

    if (bus && bus.length > 0 && bus[0].hasOwnProperty("isRTC")) {
      bus = bus.slice(1);
    }
    //for APSRTC
    if (bus[0].buses && bus[0].buses.length > 0) {
      bus[0].buses[type].forEach(d => {
        if (!data.includes(d.Name)) data.push(d.Name);
      });
    }

    bus.forEach(bus => {
      bus[type].forEach(d => {
        if (!data.includes(d.Name)) data.push(d.Name);
      });
    });
    data = data.sort();
    this.setState({
      data,
      value,
      selected
    });
  }

  selectMultipleOption = value => {
    this.setState({ selected: value });
  };

  submit = () => {
    let { value, selected } = this.state;
    value === "boarding"
      ? (value = FILTERS.FILTER_BOARDING)
      : (value = FILTERS.FILTER_DROPPING);

    this.props.filterBusList({ type: value, data: selected });
    this.props.history.goBack();
  };

  render() {
    const header = (
      <div className="header">
        <Grid container justify="flex-start" className="from-to">
          <Grid
            item
            xs={1}
            className="backBtn"
            onClick={() => {
              this.props.history.goBack();
            }}
          >
            <i className="material-icons">arrow_back</i>
          </Grid>
          <Grid item xs={5}>
            <div className="from">{`Select ${this.state.value} Point`}</div>
          </Grid>
        </Grid>
      </div>
    );

    const bottommenu = (
      <div className="bottom-fixed-details">
        <div variant="contained" className="filter-button">
          <Grid container justify="flex-start">
            <Grid item xs={12} onClick={() => this.submit()}>
              <span>{"Apply"}</span>
            </Grid>
          </Grid>
        </div>
      </div>
    );

    return (
      <div className="bus-booking filters">
        {header}
        {bottommenu}
        <div className="picky-list">
          <Picky
            value={this.state.selected}
            options={this.state.data}
            onChange={this.selectMultipleOption}
            open={true}
            valueKey="id"
            labelKey="name"
            multiple={true}
            includeSelectAll={true}
            includeFilter={true}
            dropdownHeight={600}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    busListingReducer: state.busListingReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    filterBusList: filter => {
      dispatch(filterBusList(filter));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BoardDropingPoints);
